import { render, staticRenderFns } from "./EmployerOtherIntegratedWageBaseInput.vue?vue&type=template&id=01244baa&"
import script from "./EmployerOtherIntegratedWageBaseInput.vue?vue&type=script&lang=js&"
export * from "./EmployerOtherIntegratedWageBaseInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports